// Projets mis en avant. `order` sert au tri (avant, l'ordre était encodé
// dans le titre via un préfixe "1. " / "2. " qui se retrouvait dans les <h3>).
const AIRTABLE_DATA = {
  featuredProjects: [
    {
      id: 3,
      order: 1,
      title: {
        fr: "Christian-Cutz — Application de réservation pour barbershop",
        en: "Christian-Cutz — Barbershop booking app",
      },
      desc: {
        fr: "Christian-Cutz est une application de réservation pour barbershops. Elle permet aux clients de prendre rendez-vous facilement avec leur coiffeur, qui gère ses disponibilités et ses créneaux via l'iframe du service Brevo. Lorsqu'une réservation est effectuée, le client reçoit une confirmation par courriel ainsi qu'un rappel une heure avant son rendez-vous, accompagné d'un SMS sur son numéro de téléphone. L'application est développée avec Next.js, TypeScript et Tailwind CSS, avec l'API du service de courriel Mailgun.",
        en: "Christian-Cutz is a booking app for barbershops. Clients can easily book an appointment with their barber, who manages availability and time slots through the Brevo service iframe. Once a booking is made, the client receives an email confirmation plus a reminder one hour before the appointment, along with an SMS to their phone. Built with Next.js, TypeScript and Tailwind CSS, using the Mailgun email API.",
      },
      imgUrl: "/projects/barber.png",
      isClientWork: false,
      stack: ["Nextjs", "Typescript", "Tailwind CSS"],
      url: "https://www.christian-cutz.com/",
      github: "https://github.com/StephaneNkengue/ChristianCuts_barber",
    },
    {
      id: 1,
      order: 2,
      title: {
        fr: "Les Encans de Nantes — Ventes aux enchères en ligne",
        en: "Les Encans de Nantes — Online auction platform",
      },
      desc: {
        fr: "Les Encans de Nantes est une entreprise fictive spécialisée dans la gestion d'encans virtuels, mettant principalement en avant la vente d'œuvres d'art. Les membres peuvent explorer les lots disponibles, placer des mises et enchérir tout au long de l'encan, qui se clôture par une soirée en direct. Lors de cette soirée, chaque lot dispose d'un temps limité avant sa fermeture définitive. En cas de surenchère, une minute supplémentaire est ajoutée, offrant une dernière chance aux participants. Un indicateur visuel signale les 20 dernières secondes avant la clôture de chaque lot, et les membres reçoivent des notifications par courriel en cas de surenchère ou de confirmation d'achat.",
        en: "Les Encans de Nantes is a fictional company specialising in virtual auctions, mainly for artwork. Members browse available lots, place bids and keep bidding throughout the auction, which ends with a live evening event. During that event each lot has a limited window before it closes for good. If someone outbids, an extra minute is added, giving participants one last chance. A visual indicator marks the final 20 seconds before each lot closes, and members get email notifications when they are outbid or when a purchase is confirmed.",
      },
      imgUrl: "/projects/encan.png",
      isClientWork: false,
      stack: [
        "VueJS",
        "Dotnet",
        "SQL Server",
        "Bootstrap",
        "JWT",
        "SignalR",
        "primeVue",
      ],
      url: "https://sqlinfocg.cegepgranby.qc.ca/2162067/",
      github: "https://github.com/StephaneNkengue/Projet_integration",
    },
    {
      id: 2,
      order: 3,
      title: {
        fr: "Foire des Vins — Site d'exposition et de vente de vin",
        en: "Foire des Vins — Wine fair and ticketing site",
      },
      desc: {
        fr: "La Foire des Vins est un site d'exposition et de vente de vin. Il permet aux visiteurs de consulter les lots disponibles et d'acheter leurs billets pour assister à la foire. Le site est développé avec WordPress, Elementor et Stripe.",
        en: "Foire des Vins is a wine exhibition and sales website. Visitors can browse the available lots and buy their tickets to attend the fair. Built with WordPress, Elementor and Stripe.",
      },
      imgUrl: "/projects/foire.png",
      isClientWork: true,
      stack: ["Wordpress", "Elementor", "Stripe"],
      url: "https://www.foiredesvins.ca/",
      github: "",
    },
  ],
};

module.exports = AIRTABLE_DATA;
